const cols = [
  { title: "栏目", links: [["#columns", "深挖内幕"], ["#columns", "背后真相"], ["#columns", "独家线索"], ["#columns", "深层解析"]] },
  { title: "深度内容", links: [["#feature", "头条深读"], ["#archive", "真相档案"], ["#clues", "独家线索"], ["#map", "关系图谱"]] },
  { title: "关于", links: [["#about", "关于我们"], ["#about", "拆解原则"], ["#faq", "常见问题"], ["#subscribe", "线索投稿"]] },
];

export default function Footer() {
  return (
    <footer className="bg-background-200/60">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6">
        <div className="grid gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#hero" className="flex items-center gap-2.5">
              <span className="grid h-9 w-9 place-items-center rounded-md bg-primary-500 font-heading text-lg font-black text-background-50">
                料
              </span>
              <span className="font-heading text-xl font-black tracking-tight text-foreground-950">看料网</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              专注深挖内幕与背后真相的深度内容媒体，围绕独家线索与深层解析，把被折叠的部分翻出来。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <a
                href="mailto:hello@kanliao.example.com"
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:text-primary-600"
              >
                <i className="ri-mail-line" />
                hello@kanliao.example.com
              </a>
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50 px-3 py-1.5 text-xs text-foreground-700">
                <i className="ri-eye-off-line" />
                只拆公开信息
              </span>
            </div>
          </div>

          <div className="grid grid-cols-3 gap-6 md:col-span-7">
            {cols.map((c) => (
              <nav key={c.title} aria-label={c.title}>
                <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-500">{c.title}</h4>
                <ul className="mt-3 space-y-2">
                  {c.links.map(([href, label]) => (
                    <li key={label}>
                      <a
                        href={href}
                        className="inline-flex items-center gap-1.5 text-sm text-foreground-700 transition-colors hover:text-primary-600"
                      >
                        <i className="ri-arrow-right-s-line text-background-400" />
                        {label}
                      </a>
                    </li>
                  ))}
                </ul>
              </nav>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300/70 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 看料网 KanLiao · 深度内容，仅拆解公开信息。</p>
          <p className="flex flex-wrap gap-3">
            <span className="inline-flex items-center gap-1"><i className="ri-focus-3-line" /> 可信度三级标注</span>
            <span className="inline-flex items-center gap-1"><i className="ri-refresh-line" /> 档案随时可复查</span>
          </p>
        </div>
      </div>
    </footer>
  );
}